

export type OtInboundActionType = 
| {type: 'enablePriority'}
| {type: 'disabledPriority'}
| {
    type: 'setSnackbar',
    payload: {open: boolean, message: string, status: StatusSnackbar}
    }

export type StatusSnackbar = 
| 'success'
| 'error'


export interface OtInboundState {
    isPriority: boolean,
    snackbar: {
        open: boolean,
        message: string,
        status: StatusSnackbar
    }
}

const initialState: OtInboundState = {
    isPriority: false,
    snackbar: {
        open: false,
        message: '',
        status: 'success'
    }
}

export const otInboundStateReducer =
 (state: OtInboundState = initialState,
 action: OtInboundActionType
 ): OtInboundState => {

    switch (action.type) {
        case 'enablePriority':
            return {
                ...state,
                isPriority: true
            }
        case 'disabledPriority':
            return {
                ...state,
                isPriority: false
            }
        case 'setSnackbar':
            return {
                ...state,
                snackbar: {
                    open: action.payload.open,
                    message: action.payload.message,
                    status: action.payload.status
                }
            }
        default:
            return state;
    }


 }
